<template>
  <div>
    <div class="flex items-baseline space-x-2">
      <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">Attachments</h5>

      <AttachmentManager :task-id="taskId" />
    </div>

    <div class="mt-2 space-y-2">
      <ul class="grid grid-cols-2 gap-4">
        <li v-for="attachment in attachments" :key="`${attachment.type}_${attachment.id}`">
          <LinkAttachment
            v-if="attachment.type === 'links'"
            v-bind="attachment.attributes"
            :editable="editable"
            :task-id="taskId"
          />
          <NoteAttachment
            v-else-if="attachment.type === 'notes'"
            v-bind="attachment.attributes"
            :editable="editable"
            :task-id="taskId"
          />
          <MediumAttachment
            v-else-if="attachment.type === 'media'"
            v-bind="attachment.attributes"
            :editable="editable"
            :task-id="taskId"
          />
        </li>
      </ul>

      <div v-if="attachments.length === 0" class="px-4 py-3 text-sm border border-dashed rounded">
        There are no Attachments.
      </div>
    </div>
  </div>
</template>

<script>
import AttachmentManager from './relatedAttachments/AttachmentManager.vue';
import LinkAttachment from './relatedAttachments/LinkAttachment.vue';
import MediumAttachment from './relatedAttachments/MediumAttachment.vue';
import NoteAttachment from './relatedAttachments/NoteAttachment.vue';

export default {
  name: 'RelatedAttachments',

  components: {
    LinkAttachment,
    MediumAttachment,
    NoteAttachment,
    AttachmentManager,
  },

  props: {
    editable: Boolean,
    taskId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      addAttachmentTabbedFormVisible: false,
    };
  },

  computed: {
    task() {
      return this.$store.state.entities.tasks.byId[this.taskId];
    },
    links() {
      return this.$store.getters['ui/taskLinks/linksByTask'](this.taskId);
    },
    notes() {
      return this.$store.getters['ui/taskNotes/notesByTask'](this.taskId);
    },
    media() {
      return this.$store.getters['ui/taskMedia/mediaByTask'](this.taskId);
    },
    attachments() {
      return [
        ...this.links.map((link) => ({
          type: 'links',
          id: link.id,
          attributes: {
            ...link,
          },
        })),
        ...this.notes.map((note) => ({
          type: 'notes',
          id: note.id,
          attributes: {
            ...note,
          },
        })),
        ...this.media.map((medium) => ({
          type: 'media',
          id: medium.id,
          attributes: {
            ...medium,
          },
        })),
      ];
    },
  },

  created() {
    this.load();
  },

  destroyed() {
    // this.$store.dispatch('ui/taskLinks/clear', { taskId: this.taskId });
    // this.$store.dispatch('ui/taskNotes/clear', { taskId: this.taskId });
    // this.$store.dispatch('ui/taskMedia/clear', { taskId: this.taskId });
  },

  methods: {
    load() {
      this.$store.commit({
        type: 'ui/taskLinks/setIdsByTask',
        taskId: this.taskId,
        linkIds: this.task.links,
      });

      this.$store.commit({
        type: 'ui/taskNotes/setIdsByTask',
        taskId: this.taskId,
        noteIds: this.task.notes,
      });

      this.$store.commit({
        type: 'ui/taskMedia/setIdsByTask',
        taskId: this.taskId,
        mediumIds: this.task.media,
      });
    },
    toggleAddAttachmentTabbedFormVisible() {
      this.addAttachmentTabbedFormVisible = !this.addAttachmentTabbedFormVisible;
    },
  },
};
</script>
